<template>
  <span class="hierarchy--dropdown" v-click-away="closeDropdown">
    <ds-button
      :icon="open ? 'chevron-up' : 'chevron-down'"
      class="alternate__dropdown__button"
      :label="label"
      :variant="variant"
      :size="size"
      @blur="blur"
      @click="toggle"
      @focus="focus"
    />
    <div v-if="open" class="hierarchy--dropdown__options">
      <div class="scrollable hierarchy--dropdown__background">
        <div v-for="(parent,index) in options">
          <li :title="parent.text" class="hierarchy--dropdown__group-title">
            <ds-button
              class="hierarchy--dropdown__options--items"
              :class="[index == 0 ? 'hierarchy--dropdown__first-group-title' :  'hierarchy--dropdown__other-group-title']"
              :label="parent.text"
              :variant="variant"
              size="small"
              @blur="blur"
              @focus="focus"
              @click="input(parent)"
            />
            <ds-button
              class="hierarchy--dropdown__view-all"
              v-if="index == 0 && options.length > 9"
              label="View all"
              variant="minimal"
              size="small"
              @blur="blur"
              @focus="focus"
              @click="openFiltersModal"
            />
          </li>
          <li :title="child.text" v-for="child in parent.children">
            <ds-button
              class="hierarchy--dropdown__options--items hierarchy--dropdown__child"
              :label="child.text"
              :variant="variant"
              size="small"
              @blur="blur"
              @focus="focus"
              @click="input(parent,child)"
            />
          </li>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../../store/modules/ui'
  import MODAL_IDS from '../../constants/modal-ids'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'hierarchy-dropdown',
    props: ['options', 'label', 'variant', 'selection', 'icon', 'size'],
    data () {
      return {
        open: false,
      }
    },
    methods: {
      toggle () {
        this.open = !this.open || this.active
    },
    focus () {
      this.active = true
      this.open = true
      setTimeout(() => {
        this.active = false
      }, 500)
    },
    input (parent, child) {
      if (child !== undefined) {
        this.$emit('update:modelValue', child.id)
        //this.$emit('update:modelValue', parent.text + ' > ' + child.text)
      } else {
        this.$emit('update:modelValue', parent.id)
        //this.$emit('update:modelValue', parent.text)
      }

    },
    blur () {
      setTimeout(() => {
        if (this.$el && document.activeElement && !this.$el.contains(document.activeElement)) {
          this.open = false
        }
      }, 0)
    },
    openFiltersModal () {
      this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.ALL_FILTERS)
    },
    closeDropdown (event) {
      if (event.target.parentElement && event.target.parentElement.classList.value !== 'hierarchy--dropdown') {
        this.open = false
      }
    }
  },
  })
</script>

<style lang="scss">
@import "../../../scss/_variables.scss";
.hidden__option{
  display:none !important;
}

.hierarchy--dropdown {
  position: relative;
  border: none;
  background: none;
  margin-right:1em;
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px $color-primary;
    .fill-fg {
      fill: $color-primary;
    }
  }
  &:hover .fill-fg {
    fill: $color-primary;
  }
  .button {
    text-align: left;
  }
  >.svg-icon {
    display: block;
  }

  .alternate__dropdown__button {
    max-width: 200px;
  }
}

.alternate__dropdown__button {
  width: fit-content;
  height: 33px;
  border: 1px solid $color-borders !important;
  margin-right: 0px !important;
  span {
    color: $color-text-grey-light;
    padding-left:0px !important;
    text-transform:capitalize;
  }
  .svg-icon {
    left:auto !important;
    right:15px;
    path {
      fill: $color-secondary
    }
  }
  svg {
    width:20px;
    height:20px;
    margin-top:-1px;
  }
  .button__label {
    font-family: $font-stack-primary;
    line-height:19px;
    letter-spacing: .06em;
    margin-right: 2rem;
  }
}

.hierarchy--dropdown__options {
  z-index: 110;
  min-width: 100%;
  margin-top: 5px;
  position: absolute;
  max-height:250px;
  top: 100%;
  margin-bottom: 50px;
  left: 0px;
  white-space: nowrap;
  font-size: 14px;
  text-align: left;
  background: $color-secondary;
  > .button {
    &:focus {
      z-index: 1;
    }
  }
  .svg-icon {
    width: 12px ;
    height: 12px ;
  }

  .hierarchy--dropdown__background {
    background: white;
    border-left:1px solid $color-borders;
    border-bottom:1px solid $color-borders;
    border-right:1px solid $color-borders;
    max-height:250px;
    li {
      list-style: none;
    }
    .button__label {
      font-style: normal !important;
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 4px;
    background-color: $color-secondary;
    background: $color-secondary
  }

  ::-webkit-scrollbar-thumb {
    background-color: $color-background-grey;
    -webkit-border-radius: 1ex;
  }
}

.hierarchy--dropdown__first-group-title {
  cursor:pointer;
  width: 65% !important;
  display:inline-block;
  .button__label {
    text-transform: uppercase !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    -ms-text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }
  a {
    color:$color-text-grey;
  }
}
.hierarchy--dropdown__first-group-title:hover {
  background-color: $color-background-light-grey !important;
}

.hierarchy--dropdown__view-all {
  .button {
    vertical-align: top;
    padding: 0px 5px;
    font-size: 10px;
  }
  .button__label {
    line-height:15px;
    text-transform: lowercase;
    text-decoration: underline;
    color: $color-text-grey-light;
    margin-left: -5px !important;
  }
}

.hierarchy--dropdown__other-group-title {
  cursor:pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  .button__label {
    text-transform: uppercase !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    -ms-text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }
   a {
    color:$color-text-grey;
  }
}

.hierarchy--dropdown__group-title {
  font-size:13px;
  background-color: $color-background-light-grey;
  a {
    vertical-align: top;
  }
  .button {
    vertical-align: top;
    padding: 0px 5px;
    font-size: 10px;
    line-height:15px;
    .button__label {
      padding: 6px 0 0 0;
    }
  }
}

.hierarchy--dropdown__group-title:hover {
  background-color: $color-borders;
  .button {
    background-color: $color-borders !important;
  }
}

.hierarchy--dropdown__options--items {
  width:100%;
  padding-left: 3px !important;
  .button__label {
    text-transform:capitalize;
  }
}

.hierarchy--dropdown__child {
  border-top: 1px solid $color-background-light-grey !important;
}

.hierarchy--dropdown__child:hover {
  background-color: $color-borders !important;
}

.cb-dropdown__options {
  position: absolute;
  z-index: 2;
  height: 200px;
  top: 100%;
  margin-bottom: 50px;
  left: 0px;
  white-space: nowrap;
  font-size: 14px;
  text-align: left;
  background: $color-secondary;
  > .button {
    &:focus {
      z-index: 1;
    }
  }
  .svg-icon {
    width: 12px ;
    height: 12px ;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 4px;
    background-color: $color-secondary;
    background: $color-secondary
  }

  ::-webkit-scrollbar-thumb {
    background-color: $color-background-grey;
    -webkit-border-radius: 1ex;
  }
}

.cb-dropdown__button {
  width: 95%;
  background-color: $color-background-grey !important;
  color: white !important;
  text-align: center !important;
  margin-bottom: 4px;
  margin-left: 4px;
  &:hover {
    background-color: rgba(255, 255, 255, .3);
  }
}

.cb-dropdown__button-container {
  background: $color-secondary;
  width: 100%;
}

.cb-dropdown__inactive_button {
  width: 95%;
  background-color: white !important;
  text-align: center !important;
  &:hover {
    background-color: rgba(255, 255, 255, .3);
  }
}
</style>
